import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from './firebase';

// Set default values
remoteConfig.defaultConfig = {
  claudeModel: '',
  environment: '',
  frontEndUrl: '',
  gptModel: 'gpt-4o-mini-2024-07-18',  // Added default GPT model
  monthlyFreeDebates: '',
  monthlyPlanCostPro: '30',
  monthlyPlanCostUltimate: '100',
  stripePublicKey: '',
  stripeProSubscriptionPriceId: '',
  stripeUltimateSubscriptionPriceId: '',
};

// Fetch remote config values
export const initializeRemoteConfig = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    return true;
  } catch (error) {
    console.error('Error fetching remote config:', error);
    return false;
  }
};

// Determine if we're running in local development
const isLocalDevelopment = window.location.hostname === 'localhost';

export const getRemoteConfigValue = (key) => {
  const value = getValue(remoteConfig, key);
  
  // Special handling for frontendUrl in local development
  if (key === 'frontendUrl' && isLocalDevelopment) {
    return 'http://localhost:3000';
  }
  
  return value.asString();
};

export const getConfigValues = () => ({
  environment: getRemoteConfigValue('environment'),
  stripePublicKey: getRemoteConfigValue('stripePublicKey'),
  stripeProSubscriptionPriceId: getRemoteConfigValue('stripeProSubscriptionPriceId'),
  stripeUltimateSubscriptionPriceId: getRemoteConfigValue('stripeUltimateSubscriptionPriceId'),
  frontendUrl: getRemoteConfigValue('frontendUrl'),
  monthlyFreeDebates: getRemoteConfigValue('monthlyFreeDebates'),
  proPlanMonthlyPrice: getRemoteConfigValue('monthlyPlanCostPro'),
  ultimatePlanMonthlyPrice: getRemoteConfigValue('monthlyPlanCostUltimate'),
});